import React from 'react';
import DetailCourseContainer from '../../Componant/Learning/DetailCourse';

const DetailCourse = () => {
  return (
    <div className='page-body'>
      <DetailCourseContainer />
    </div>
  );
};

export default DetailCourse;
